.root {
    padding-inline: var(--labui-container-margin);
    padding-block: var(--spacer-80);

    &.gradient {
        background: var(--xcient-gradient);
    }

    h3 {
        font: var(--font-h-32);
        padding-block: var(--spacer-32);
        border-bottom: 1px solid var(--color-contrast);
    }

    svg {
        aspect-ratio: 1;
        height: 1lh;
        fill: currentColor;
        transition: rotate 500ms;
    }

    & [data-expanded] {
        svg {
            rotate: 45deg;
        }

        .panel {
            max-height: 500px;
            opacity: 1;
        }
    }
}

.header {
    font: var(--font-h-64);
    margin-bottom: var(--spacer-80);
}

.button {
    composes: buttonReset from "../../styles/composable/utility.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    width: 100%;
    justify-content: space-between;
    text-align: left;
}

.panel {
    margin-top: var(--spacer-24);
    transition:
        max-height 500ms,
        opacity 300ms;
    max-height: 0;
    opacity: 0;

    &[hidden] {
        content-visibility: unset;
        pointer-events: none;
    }
}
